import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import DefaultSlider from './DefaultSlider';

import vw from 'styles/utils';

function SlickBar(props) {
  const { icon, title, children } = props;
  const settings = {
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }

  return (
    <Root>
      <Row>
        <Icon src={icon}/>
        <Title>{title}</Title>
      </Row>
      <DefaultSlider {...settings}>
        {children}
      </DefaultSlider>
    </Root>
  )
}

SlickBar.propTypes = {
  icon: PropTypes.any, 
  title: PropTypes.string, 
  children: PropTypes.any
}

const Root = styled.div`
  .slick-arrow {
    display: none !important;
  }
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #DADADA;

  ${vw('padding-bottom', 8, 15)}
  ${vw('margin-bottom', 8, 15)}

  > img {
    width: auto;
    height: auto;

    ${vw('max-width', 12, 18)}
    ${vw('max-height', 12, 18)}
  }
`;

const Icon = styled.img`
  height: fit-content;

  ${vw('margin-right', 6, 10)}
`;

const Title = styled.h5`
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 500;

  ${vw('font-size', 12, 18)}
  ${vw('line-height', 20, 28)}
`;

export default SlickBar
